import React from 'react';
import { Badge, IconButton, Tooltip, useMediaQuery } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useNavigate } from 'react-router-dom';

const NavBarActionableTrades = () => {
    const navigate = useNavigate();
    const isSmUp = useMediaQuery('(min-width:640px)');
    const isTextVisible = useMediaQuery('(min-width:1536px)');
    const actionableTrades = useSelector((state: RootState) => state.auth.statistics?.actionableTrades || 0);

    if (actionableTrades === 0 || !isSmUp) {
        return null;
    }

    return (
        <Tooltip title="Actionable Trades" disableHoverListener={isTextVisible}>
            <IconButton
                onClick={() => navigate('/profile/trades')}
                size="medium"
                sx={{
                    height: 40,
                    px: { xs: 1, '2xl': 1.5 },
                    color: 'primary.contrastText',
                    backgroundColor: 'primary.main',
                    border: '1px solid',
                    borderColor: 'primary.dark',
                    borderRadius: '8px',
                    '&:hover': {
                        backgroundColor: 'primary.dark',
                    },
                }}
            >
                <div className="flex items-center 2xl:space-x-2 space-x-0">
                    <SwapHorizIcon />
                    <div className="relative inline-flex items-center">
                        <span className="hidden 2xl:inline text-xs font-bold uppercase tracking-wider whitespace-nowrap pl-1 pr-2">
                            Actionable Trades
                        </span>
                        <Badge
                            badgeContent={actionableTrades > 99 ? '99+' : actionableTrades}
                            color="error"
                            sx={{
                                '& .MuiBadge-badge': {
                                    position: { xs: 'absolute', '2xl': 'relative' },
                                    transform: { xs: 'scale(1)', '2xl': 'none' },
                                    right: { xs: -14, '2xl': 'auto' },
                                    top: { xs: -24, '2xl': 'auto' },
                                    ml: { '2xl': 1 },
                                }
                            }}
                        />
                    </div>
                </div>
            </IconButton>
        </Tooltip>
    );
};

export default NavBarActionableTrades;